export const leads = {
  title: 'Leads',
  subtitle: 'Manage potential customers',
  
  // Actions
  actions: {
    newLead: 'New Lead',
    refresh: 'Refresh',
    embed: 'Embed Form',
    embedShort: 'Embed',
    edit: 'Edit',
    delete: 'Delete',
    convert: 'Convert',
    comments: 'Comments',
    viewComments: 'View Comments'
  },
  
  // Status
  status: {
    new: 'New',
    contacted: 'Contacted',
    qualified: 'Qualified',
    unqualified: 'Unqualified',
    converted: 'Converted',
    all: 'All'
  },
  
  // Source
  source: {
    website: 'Website',
    manual: 'Manual',
    referral: 'Referral',
    social_media: 'Social Media',
    advertisement: 'Advertisement',
    other: 'Other'
  },
  
  // Table columns
  columns: {
    name: 'Name',
    contact: 'Contact',
    company: 'Company',
    status: 'Status',
    source: 'Source',
    score: 'Score',
    created: 'Created',
    actions: 'Actions'
  },
  
  // Form
  form: {
    title: {
      create: 'New Lead',
      edit: 'Edit Lead'
    },
    fields: {
      name: 'Name',
      namePlaceholder: 'Full name',
      email: 'Email',
      emailPlaceholder: 'email@example.com',
      phone: 'Phone',
      phonePlaceholder: '+36 30 123 4567',
      company: 'Company',
      companyPlaceholder: 'Company name',
      source: 'Source',
      score: 'Lead Score (0-100)',
      scorePlaceholder: '0',
      scoreHelp: 'Higher score indicates higher conversion probability',
      notes: 'Notes',
      notesPlaceholder: 'Additional information about the lead...'
    },
    sections: {
      basicInfo: 'Basic Information',
      evaluation: 'Evaluation and Notes'
    },
    buttons: {
      cancel: 'Cancel',
      save: 'Save',
      create: 'Create'
    }
  },
  
  // Messages
  messages: {
    created: 'Lead created successfully!',
    updated: 'Lead updated successfully!',
    deleted: 'Lead deleted successfully!',
    statusUpdated: 'Status updated',
    converted: 'Lead successfully converted to customer!',
    error: 'An error occurred',
    errorLoading: 'Error loading leads',
    errorCreating: 'Error creating lead',
    errorUpdating: 'Error updating lead',
    errorDeleting: 'Error deleting lead',
    errorStatus: 'Error updating status',
    deleteConfirm: 'Are you sure you want to delete this lead?',
    deleteWarning: 'This action cannot be undone.',
    nameRequired: 'Please enter a name!'
  },
  
  // Search and filter
  search: {
    placeholder: 'Search by name, email, company or phone...',
    noResults: 'No results',
    resultsCount: '{count} results'
  },
  
  // Empty states
  empty: {
    title: 'No leads',
    subtitle: 'Start adding new leads!',
    noResults: 'No results matching your search criteria'
  },
  
  // Conversion
  conversion: {
    title: 'Convert Lead to Customer',
    success: 'Lead successfully converted to customer!',
    error: 'Error converting lead'
  },
  
  // Comments
  comments: {
    title: 'Comments',
    add: 'New comment',
    placeholder: 'Write a comment...',
    send: 'Send',
    delete: 'Delete Comment',
    deleteConfirm: 'Are you sure you want to delete this comment?',
    empty: 'No comments yet',
    internal: 'Internal note'
  },
  
  // Embed
  embed: {
    title: 'Embed Lead Form',
    description: 'Customize the form on the left, copy the embed code on the right.',
    customize: 'Customize',
    preview: 'Preview',
    code: 'Embed Code',
    copy: 'Copy Code',
    copied: 'Embed code copied!'
  },
  
  // Pagination
  pagination: {
    showing: 'Showing',
    of: 'of',
    results: 'results',
    previous: 'Previous',
    next: 'Next'
  }
};
